import {
    setLocalToken,
    getLocalToken,
    removeLocalToken,
    removeUserInfo
} from '@/store/index'
import {
    Message
} from 'element-ui'
import md5 from 'js-md5'
import axios from 'axios'
import router from '@/router'
import {
    createCode
} from '@/helper/utils'
// Api默认服务器地址
axios.defaults.baseURL = config.baseUrl
// 设置apiget post type为json格式
axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

axios.defaults.crossDomain = true;
axios.defaults.withCredentials = true; //设置cross跨域 并设置访问权限 允许跨域携带cookie信息

/*
 * Http Get方法
 */
export const get = (url, params) => {
    return new Promise((resolve, reject) => {
        axios.get(axios.defaults.baseURL + url, {
                params: params
            })
            .then(response => {
                // if(!response.data.success){
                //     resolve(response.data)
                //     reject(response.data.reason)
                //     return
                // }

                resolve(response.data)
            }, err => {
                if (err) {
                    reject(err);
                }
            })
            .catch((error) => {
                reject(error)
            })
    })
}

/*
 * Http Post方法
 */
export const post = (url, body, params) => {
    return new Promise((resolve, reject) => {
        axios.post(axios.defaults.baseURL + url, body, {
                params: params
            })
            .then(response => {
                if (!response.data.success) {
                    reject(response.data.reason)
                    return
                }
                resolve(response.data)
            }, err => {
                if (err) {
                    reject(err);
                }
            })
            .catch((error) => {
                reject(error)
            })
    })
}

/*
 * Api Token获取
 */
export function getToken({
    grant_type,
    username,
    password,
    openid,
    isopenidlogin,
    login_type,
    user_type
}) {
    var url = '/api/token'; // token固定地址
    var _params = "grant_type=" + grant_type + "&username=" + username + "&password=" + password + "&openid=" + openid + "&isopenidlogin=" + isopenidlogin + "&user_type=" + user_type + "&login_type=" + login_type + "&r=" + createCode();
    return new Promise((resolve, reject) => {
        axios.post(axios.defaults.baseURL + url, _params)
            .then(response => {
                if (response && response.data) {
                    setLocalToken(response.data.access_token);
                }

                resolve(response);
            }, err => {
                if (err) {
                    reject(err);
                }
            })
            .catch((error) => {
                var msg = "";
                if (error != undefined) {
                    msg = error.response.data.error_description;
                }
                reject(msg)
            })
    })
}

// 配置发送请求前的拦截器 可以设置token信息 
axios.interceptors.request.use(
    config => {
        /* // 这里配置全局loading
        if (!(/\.json/.test(config.url))) {
            $('#screen').show() // 这个div控制loading动画，项目中有对json的请求，所以这里区分是否是json文件
        } */

        // 也可以在这里检查token,需要就加
        if ((/\token/.test(config.url))) {
            //console.log(config.url);
        }

        // 统一设置请求header
        config.headers = getCustomHeader()

        return config
    }, error => {
        return Promise.reject(error)
    }
)

// 配置响应拦截器 

axios.interceptors.response.use(
    res => {
        return Promise.resolve(res) // 这里直接返回data, 即接口返回的所有数据
    }, error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    //一般401是Token过期
                    // Message({
                    //     message: '登录已过期，请重新登录',
                    //     type: 'error',
                    //     center: true
                    // })
                    removeLocalToken()
                    removeUserInfo()
                    //console.log(router);
                    localStorage.removeItem('userType')
                    router.push('/Login')
                    //router.go(0)
                    return Promise.reject(null);
                case 400:
                    // 一般登录出错会报400
                    return Promise.reject(error.response.data);
                default:
            }
        }

        // 其它错误，直接返回个错误        
        return Promise.reject("系统错误")
    }
)


// 设置默认主机地址
export function setDefaultUrl(url) {
    axios.defaults.baseURL = url;
}

// 设置header
export function setHeader(key, value) {
    axios.defaults.headers.common[key] = value;
}

/*
const setAuthorization = function(tokenId, tokenType){
    var type = tokenType ? tokenType : "Bearer";
    setHeader('Authorization', `${type} ${tokenId}`);
}
*/

// 自定义请求header
export const getCustomHeader = () => {
    let _token = getLocalToken()
    let timestamp = Math.round(new Date().getTime() / 1000)
    let nonce = process.env.VUE_APP_JWT_NONCE_STRING
    let encrypt = process.env.VUE_APP_JWT_ENCRYPT_STRING
    var signature = md5(encrypt + timestamp + nonce).toString().toUpperCase()

    var header = {
        'timestamp': timestamp,
        'nonce': nonce,
        'signature': signature
    };
    if (_token != null) {
        header.Authorization = 'bearer ' + _token
    }

    return header
}